<script lang="ts">
    import type {Accessory} from "./Accessory";
    import {cannedAccessories} from "./cannedAccessories";
    import {accessories as selectedAccessories, totalPriceToTwoDecimalPlaces} from "./stores";
    import {push} from 'svelte-spa-router'
    import CouponCodeEntry from "./CouponCodeEntry.svelte";
    import {applicableAccessories} from "./state/appState";

    $: accessories = $applicableAccessories.length > 0 ? $applicableAccessories : cannedAccessories

    function toggleAccessory(accessory: Accessory) {
        const maybeAlreadySelected = $selectedAccessories.find(a => a.id === accessory.id)
        if (maybeAlreadySelected) {
            $selectedAccessories = $selectedAccessories.filter(a => a.id !== accessory.id)
        } else {
            $selectedAccessories = [...$selectedAccessories, accessory]
        }
    }
</script>

<div class="mt-2 text-left accessories-container">
    <div class="text-center my-2">Total = £ {$totalPriceToTwoDecimalPlaces}</div>
    <h4>Add to your appointment...</h4>
    {#each accessories as accessory}
        <div class="form-check" on:click={() => toggleAccessory(accessory)}>
            <input class="form-check-input accessory" type="checkbox" value={accessory.id} id={accessory.id}
                   checked={$selectedAccessories.some(a => a.id === accessory.id)}>
            <label class="form-check-label" for={accessory.id}>
                {accessory.label}
                <br/>
                £ {accessory.priceLabel}
            </label>
        </div>
    {/each}
</div>
<CouponCodeEntry />

<div class="mt-2 text-left accessories-container">
    <button class="btn btn-success rounded px-5 py-2 next-button" on:click={() => push("/aboutYou")}>Next</button>
</div>